import CryptoJS from 'crypto-js'

const TOKEN_KEY = 'a'
const SECRET_KEY = process.env.REACT_APP_SECRET_KEY as string

if (!SECRET_KEY) {
  throw new Error('REACT_APP_SECRET_KEY is not defined')
}

export const saveToken = (token: string) => {
  const encrypted = CryptoJS.AES.encrypt(token, SECRET_KEY).toString()
  localStorage.setItem(TOKEN_KEY, encrypted)
}

export const getToken = (): string | null => {
  const encrypted = localStorage.getItem(TOKEN_KEY)
  if (!encrypted) return null

  try {
    const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY)
    const token = bytes.toString(CryptoJS.enc.Utf8)
    return token || null
  } catch {
    return null
  }
}

export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY)
}
